var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShield(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7422 3.04688L7.49219 0.859375C7.35547 0.804688 7.13672 0.777344 7 0.777344C6.83594 0.777344 6.61719 0.804688 6.48047 0.859375L1.23047 3.04688C0.738281 3.26562 0.4375 3.73047 0.4375 4.25C0.4375 9.69141 3.55469 13.4375 6.48047 14.668C6.80859 14.8047 7.16406 14.8047 7.49219 14.668C9.84375 13.6836 13.5625 10.3203 13.5625 4.25C13.5625 3.73047 13.2344 3.26562 12.7422 3.04688ZM7.16406 13.8477C7.05469 13.9023 6.91797 13.9023 6.80859 13.8477C4.15625 12.7812 1.3125 9.0625 1.3125 4.25C1.3125 4.08594 1.39453 3.92188 1.55859 3.86719L6.80859 1.67969C6.91797 1.625 7.05469 1.625 7.16406 1.67969L12.4141 3.86719C12.5781 3.92188 12.6602 4.08594 12.6602 4.25C12.6875 9.0625 9.84375 12.7812 7.16406 13.8477Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/Shield.e3f3628e2c2a76c362d70e2d0e9f19d6.svg";
export { ForwardRef as ReactComponent };